import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import ClickableDescr from 'components/ClickableDescr'
import Icon from 'components/Icon'
import SectionWrapper from 'components/SectionWrapper'
import { ResizeContext } from 'contexts/Resize'
import { useSwitcher } from 'hooks/saveElementIndex'
import { H1Small as H1 } from 'styles/components/typography'

import {
  Cover,
  FrameWrapper,
  IconWrapper,
  Content,
  FrameMacSideStyled,
} from './styles'

const IMAGES = [
  'nutrition_metabolism',
  'nutrition_behaviour',
  'nutrition_vitamins',
  'nutrition_intolerance',
  'nutrition_recommendations',
]

const WResultsNutrition = props => {
  const { data, pathCdn } = props
  const { index, updateIndex } = useSwitcher()
  const { mobile } = React.useContext(ResizeContext)
  const { colors } = React.useContext(ThemeContext)

  return (
    <SectionWrapper
      isOverflowHidden={true}
      beforeElement={<Cover isTablet={true} />}
    >
      <div className="row">
        <div className="col-12 col-md-8">
          <Cover />
          <FrameWrapper className="py-md-4">
            <div className="position-relative py-4 py-md-0">
              <H1 as="h2" dangerouslySetInnerHTML={{ __html: data.title }} />
              <FrameMacSideStyled
                src={`${pathCdn}/${IMAGES[index]}`}
                alt={IMAGES[index]}
              >
                <IconWrapper className="pie">
                  <Icon id="color_pie" />
                </IconWrapper>
                <IconWrapper className="nutrition">
                  <Icon id="color_nutrition" />
                </IconWrapper>
              </FrameMacSideStyled>
            </div>
          </FrameWrapper>
        </div>
        <div className="col-12 py-4 col-md-4">
          <Content>
            <ul className="list--unstyled w-100">
              {data.list.map((item, key) => (
                <ClickableDescr
                  bulletColor={colors.lilacDark}
                  key={key}
                  isActive={index === key}
                  noHover={mobile || data.list.length === 1}
                  onClick={() => updateIndex(key)}
                  data={{
                    title: item.title,
                    description: item.content,
                  }}
                  arrowPosition="left"
                  arrowColor={colors.white}
                />
              ))}
            </ul>
          </Content>
        </div>
      </div>
    </SectionWrapper>
  )
}

WResultsNutrition.propTypes = {
  data: PropTypes.object.isRequired,
  pathCdn: PropTypes.string.isRequired,
}

export default WResultsNutrition
